import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
const RefereeDetail = () => {


    return (
        <>
            <div className="page-wrapper">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Referee Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Referee Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <section className="referees-dtl">
                        <div className="referee-modal">
                            <div class="back-arrow-new"><a href="/referee-management"><i class="bx bx-arrow-back"></i></a></div>
                            <div className="modal-header-custom">
                                <h5>Referee Details</h5>
                            </div>
                            {/* Personal Details */}
                            <div className="detail-section">
                                <h6>Personal Details</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="label">Name</p>
                                        <p className="value">Alex Turner</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Email</p>
                                        <p className="value">alex.turner@example.com</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Phone Number</p>
                                        <p className="value">+1 456 789 123</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Age</p>
                                        <p className="value">16 years</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Country</p>
                                        <p className="value">United States</p>
                                    </div>
                                </div>
                            </div>
                            {/* Connected Parent Details */}
                            <div className="detail-section">
                                <h6>Connected Parent Details</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="label">Parent Name</p>
                                        <p className="value">Michael Turner</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Email</p>
                                        <p className="value">michael.turner@example.com</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Contact Number</p>
                                        <p className="value">+1 456 789 000</p>
                                    </div>
                                </div>
                            </div>
                            {/* Professional Details */}
                            <div className="detail-section">
                                <h6>Professional Details</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="label">Experience Level</p>
                                        <p className="value">Junior (2+ years)</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">License Number</p>
                                        <p className="value">REF-2026-00287</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Match Count</p>
                                        <p className="value">52 matches</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Certifications</p>
                                        <span className="badge bg-success">Basic Referee Course</span>
                                        <span className="badge bg-success">Youth Badge</span>
                                    </div>
                                </div>
                            </div>
                            {/* Bank Details */}
                            <div className="detail-section">
                                <h6>Bank Details (Parent Account)</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="label">Bank Name</p>
                                        <p className="value">Community Bank</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Account Title</p>
                                        <p className="value">Michael Turner</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Account Number</p>
                                        <p className="value">****5678</p>
                                    </div>
                                </div>
                            </div>
                            {/* Ratings */}
                            <div className="detail-section">
                                <h6>Ratings &amp; Reviews</h6>
                                <div className="overall-rating">
                                    <i className="bx bxs-star" />
                                    <i className="bx bxs-star" />
                                    <i className="bx bxs-star" />
                                    <i className="bx bxs-star" />
                                    <i className="bx bxs-star-half" />
                                    <span>4.8</span>
                                </div>
                                <div className="review-item">
                                    <div>
                                        <p className="game">Professionalism</p>
                                        <p className="comment">Excellent professionalism</p>
                                    </div>
                                    <div className="review-rating">
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <span>98%</span>
                                    </div>
                                </div>
                                <div className="review-item">
                                    <div>
                                        <p className="game">Punctuality</p>
                                        <p className="comment">Always on time</p>
                                    </div>
                                    <div className="review-rating">
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <span>100%</span>
                                    </div>
                                </div>
                                <div className="review-item">
                                    <div>
                                        <p className="game">Decision Making</p>
                                        <p className="comment">Accurate match decisions</p>
                                    </div>
                                    <div className="review-rating">
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <span>95%</span>
                                    </div>
                                </div>
                            </div>
                            {/* Documents */}
                            <div className="detail-section">
                                <h6>Documents</h6>
                                <ul className="document-list">
                                    <li>Referee License <i className="bx bx-download" /></li>
                                    <li>Background Check Certificate <i className="bx bx-download" /></li>
                                    <li>Resume / CV <i className="bx bx-download" /></li>
                                </ul>
                            </div>
                            {/* Hiring Status / Games */}
                            <div className="detail-section">
                                <h6>Scheduled &amp; Completed Games</h6>
                                <span className="badge bg-primary me-2">8 Scheduled Games</span>
                                <span className="badge bg-success">12 Completed Games</span>
                                <div className="mt-2">
                                    <p><strong>Status:</strong> Hired</p>
                                </div>
                            </div>
                        </div>
                    </section>


                </div>
            </div>




        </>
    )
}

export default RefereeDetail